// extracted by mini-css-extract-plugin
export default {"wrapper":"_w-z","viewport":"ax-z","container":"bx-z","slide":"cx-z"};